class NotificationService {
    constructor($rootScope, $log) {
        this._log = $log;
        this._rootScope = $rootScope;
        this._isApplicationActive = true;

        window.onfocus = () => this._isApplicationActive = true;
        window.onblur = () => this._isApplicationActive = false;

        this.init();
        this.bindHandlers();
    }

    init() {
        this._showNotifications = false;

        if (!(window.Notification && window.Notification.requestPermission())) {
            this._log.error("This browser does not support desktop notification");
        } else {
            Notification.requestPermission().then((result) => {
                this._log.info("Notifications accepted");
                this._showNotifications = true;
            });
        }
    }

    bindHandlers() {
        var unbindCallOfferReceived = this._rootScope.$on('privateCallService.callOfferReceived', (e, data) => {
            this.notifyIfInactive("WAVE: Incoming call from " + data.callerInfo);
        });

        var unbindCallHangupReceived = this._rootScope.$on('privateCallService.callHangupReceived', (e, data) => {
            this.notifyIfInactive("WAVE: Call ended.");
        });

        var unbindCallConnected = this._rootScope.$on('privateCallService.callConnected', (e, data) => {
            //this._log.warn("connected: data", data);
            this.notifyIfInactive("WAVE: Call connected.");
        });

        this._rootScope.$on('destroy', (e) => {
            unbindCallOfferReceived();
            unbindCallHangupReceived();
            unbindCallConnected();
        });
    }

    notifyIfInactive(message) {
        if (!this._isApplicationActive && this._showNotifications) {
            this._log.info("Sending notification message: ", message);
            let notification = new Notification(message);
            notification.onclick = () => window.focus(); // this might be redundant, but it seems to work in Linux. verify in Win/OSX
        }
    }
}

angular.module('webcomm').service('notificationService', ['$rootScope', '$log', NotificationService]);